import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

/**
 * Ресурс і операція, за якими відкривається сторінка «Довідники» та всі
 * `/settings/<довідник>` (`SPEC-007` §7.1). Той самий вхід у
 * `GATED_MENU_ITEMS['Setting.Index']`, щоб пункт меню й маршрут не
 * розходилися.
 */
export const DICTIONARY_PAGE_GATE = { resource: 'Setting.ListClientStatus', operation: 'create' } as const

/**
 * Чи відкривати сторінку «Довідники» і сторінки довідників.
 *
 * Право — те, яке бек дає лише адміністратору (`STATUS_LIST_CREATE`,
 * `SPEC-003` §2.3), а не роль: ролі на фронті довелося б звіряти з ієрархією
 * `security.yaml`. Читати довідники може кожен (селекти карток), тож право
 * читання тут не годиться — сторінку бачив би будь-хто.
 *
 * ⚠️ У легасі маршрути `/list/*` не перевірялися зовсім: меню ховало пункт, а
 * пряма адреса відкривала будь-кому.
 */
export const CheckDictionaryPageAccessTask = (): boolean =>
    CheckGlobalResourceAccessTask(DICTIONARY_PAGE_GATE.resource, DICTIONARY_PAGE_GATE.operation)
